export const SubscriptionTypeOptions: SelectOption<number>[] = [
    { label: 'Mailbox Notifications', value: 0 },
    { label: 'Calendar Monitor', value: 1 }
];